import { Col as BaseCol, ColProps as BaseColProps } from 'antd'

export interface ColProps extends BaseColProps {}

export const Col = (props: ColProps): JSX.Element => (
  <>
    <BaseCol {...props} />
  </>
)
